import { render, staticRenderFns } from "./userTypeToggle.vue?vue&type=template&id=0cd9110a"
import script from "./userTypeToggle.vue?vue&type=script&lang=js"
export * from "./userTypeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports